import React from 'react';
import { FiInfo } from 'react-icons/fi';
import styles from './AuditTrail.module.css';
import { formatDateTimeWithSeconds } from '../../utils/dateFormatter';
import LoadingContainer from '../../components/Common/LoadingContainer';

const AuditTable = ({ auditLogs, loading, onViewDetails }) => {
    const formatTimestamp = formatDateTimeWithSeconds;

    if (loading) {
        return <LoadingContainer message="Loading audit logs..." />;
    }

    if (auditLogs.length === 0) {
        return (
            <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                No audit logs found
            </div>
        );
    }

    return (
        <table className={styles.table}>
            <thead className={styles.tableHead}>
                <tr>
                    <th>User Name</th>
                    <th>Role</th>
                    <th>Module</th>
                    <th>Action Type</th>
                    <th>IP Address</th>
                    <th>Timestamp</th>
                    <th>Remarks</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody className={styles.tableBody}>
                {auditLogs.map((log, index) => (
                    <tr key={log.audit_id || index} className={styles.tableRow}>
                        <td>{log.full_name || '-'}</td>
                        <td><span className={styles.roleBadge}>{log.role_name || '-'}</span></td>
                        <td>{log.module_name || '-'}</td>
                        <td><span className={styles.actionBadge}>{log.action_type || '-'}</span></td>
                        <td>{log.ip_address || '-'}</td>
                        <td>{formatTimestamp(log.timestamp)}</td>
                        <td>{log.remark || '-'}</td>
                        <td>
                            <button
                                className={styles.infoButton}
                                onClick={() => onViewDetails(log.audit_id)}
                                title="View Details"
                            >
                                <FiInfo />
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default AuditTable;